import React from "react";
import { Link } from "react-router-dom";
import Service from '../../service/Service';
import * as actions from '../Actions';

const service = new Service();

export default function MoreContest({ eleRef, leatherDetails}) {
    return (
        <div>
        {leatherDetails && leatherDetails.length > 0 ?
            leatherDetails && leatherDetails.length > 0 && leatherDetails.map((value, index) =>
            <div>
            {/* <input type="hidden" id={`record${value.records.count}`} value={record}/> */}
            {value.records && value.records.length > 0 && value.records.map((result, index) =>
            <div className="contesttype">
                <div className="image_cont left">
                  <a href={`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.contestId}`} key={result.index}>
                    <div className="contest-img" key = {result.contestId}>
                      <img className="imageClass" src={result.banners[0].bannerUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = result.banners[0].bannerUrl.replace("http://", "https://"))} />
                    </div>
                  </a>
                </div>
                <div className="contest-text left">
                    <a href={`/baby-photo-contest/contest/${this.loadcontestName(result.title)}/${result.contestId}`} key = {result.contestId}>
                        <span className="title M14_42" id={`cont-ttl_${result.contestId}`}>{result.title}</span>
                        { value.record.conType == 'active' ?
                        <div>
                            {result.isActive==1 ? 
                            <div className="inprogress R13_green">
                                <span className="dot"></span>In Progress
                            </div>
                            :
                            <div className="closed R15_red">Closed</div>
                        }
                        </div>
                        :
                        <div>
                            {result.isActive==1 ?
                            <div className="inprogress R13_green">
                                <span className="dot"></span>In Progress
                            </div>
                            :
                            <div className="closed"><span className="dot dotgrey"></span>
                                Closed
                            </div>
                            }
                        </div>
                        }
                        <span className="contest-descp R14_42" id="cont-descp">{result.description}</span>

                        <div className="cont-period">
                            <span className="period-text fl R14_9e">Contest Period :</span>
                            <span id="cont-date" className="fl M14_42">{actions.formatArticleDate(result.startDate)} - {actions.formatArticleDate(result.endDate)}</span>
                        </div>
          
                        <div className="result-date" id="rslt-date">
                            <span className="results R14_9e">Result Date :</span>
                            <span id="result-dt" className="M14_42 devresdate">{actions.formatArticleDate(result.resultDate)}</span>
                        </div> 
                    </a>
                    { value.record.conType == 'active' ?
                    <a href={`/memories/memoriesUpload?${result.contestId}`} className="landing-btn cont-btns askB_1" id="upload-img">
                      <span data-icon-font="&#xe000;" className="icon"></span>
                      <span className="M16_white">UPLOAD PHOTO</span>
                    </a>
                    :
                    <a href={`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/winners/${result.contestId}`} className="landing-btn cont-btns viewactive askB_1" id="view-winners" style="padding-top:4px">
                        <span className="M16_white dev_view-winners"  id={`dev_view-winners_${result.contestId}`}>VIEW WINNERS</span>
                    </a>
                    }
                    <div className="view-det">
                     <a href={`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.contestId}`} className="R14_link" id="rules">View Details To Know More</a>
                  </div>
                </div>
            </div>
            
            )}
            </div>
            )
            : null
            }
        </div>
    )
}
